export default {"src":"/_next/static/media/city-animated.c8976a07.svg","height":400,"width":700,"blurWidth":0,"blurHeight":0};